/** Hosts that serve production. Any other host shows the non-production banner. */
const HOSTS_PRODUCCION = ['menta.contadoresnet.com', 'brainhub.contadoresnet.com']

export const esHostDeProduccion = (hostname: string) => HOSTS_PRODUCCION.includes(hostname)

export const esEntornoNoProductivo = () =>
  typeof window !== 'undefined' && !esHostDeProduccion(window.location.hostname)
